<template>
  <div v-if="toast.show" @click="hideToast" class="toast__overlay column center">
    <div
      v-motion
      :initial="{ opacity: 0, scale: 0.9 }"
      :visibleOnce="{
        opacity: 1,
        scale: 1,
        transition: { duration: 200, ease: 'easeinout' },
      }"
      class="toast__content"
    >
      {{ t(toast.message) }}
    </div>

    <div @click="hideToast" class="close__btn row center">
      <i class="fa-solid fa-x"></i>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'Toast',
  setup() {
    const store = useStore()
    const toast = computed(() => store.getters.getToastNotification)

    const hideToast = () => {
      store.commit('clearToastMessage')
    }

    return {
      toast,
      hideToast,
    }
  },
}
</script>

<style lang="scss" scoped>
.toast__overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 20;
  background: rgba(0, 0, 0, 0.8);

  .toast__content {
    padding: 30px;
    background-color: var(--base);
    z-index: 5;
    border-radius: 15px;
    max-width: 270px;
    text-align: center;
  }

  .close__btn {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    margin-top: 10px;
    background-color: var(--base);
    cursor: pointer;

    &:hover,
    &:active {
      transform: scale(0.98);
    }

    i {
      font-size: 1.25rem;
    }
  }
}
</style>
